import { ProductCardType } from '@/constants'
import { useNotification } from '@/containers'
import type { Product, Promotion } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ProductCard from '../ProductCard'

type ProductTabProps = {
  data: Promotion
}

const ExclusiveDeal = ({ data }: ProductTabProps) => {
  const { systemConfig } = useNotification()

  const qtt =
    systemConfig?.imageQlt && systemConfig?.imageQlt != ''
      ? systemConfig?.imageQlt
      : 70
  const customStyle = {
    backgroundColor: data?.customization?.blockBackgroundColor || '#fff',
    backgroundImage:
      data?.customization?.backgroundImage &&
      `url(${data?.customization?.backgroundImage}?format=webp&quality=${qtt})`,
    backgroundRepeat: data?.customization?.backgroundImage && 'no-repeat',
    backgroundPosition: data?.customization?.backgroundImage && 'top let',
    backgroundSize: data?.customization?.backgroundImage && 'cover',
    paddingTop: data?.customization?.backgroundImage && '60px',
  }

  return (
    <section>
      <div className='exclusive-deal' style={customStyle}>
        {!data?.customization?.backgroundImage && (
          <div>
            <h2 className='font-bold text-lg px-2 py-3'>
              {getTranslate(data?.name)}
            </h2>
          </div>
        )}
        {data?.products.length > 0 && (
          <>
            <div className='exclusive-product'>
              <div className='max-w-screen grid grid-cols-2 gap-2 px-2'>
                {data?.products &&
                  data?.products.length > 0 &&
                  data?.products.map((product: Product, idx: number) => (
                    <ProductCard
                      key={product._id + idx + 'fs'}
                      product={product}
                      type={
                        product.flashSale
                          ? ProductCardType.FLASH_SALE
                          : ProductCardType.PRODUCT_CARD
                      }
                      layout={2}
                      className=''
                    />
                  ))}
              </div>

              <div className=''>
                <Link
                  href={data?.customization?.viewMoreLink || '/'}
                  className='text-mainBody text-center font-bold text-redPico overflow-hidden h-6 leading-6 block px-3 mt-3'
                >
                  {`Xem thêm sản phẩm >>>`}
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  )
}
export default ExclusiveDeal
